import { combineReducers } from "redux-immutable";

import { ClassStateSlice } from "../models";
import classesReducer from "./state/classes";
import classesMetaReducer from "./state/meta";
import manageClassesReducer from "./state/manageClasses";

export default combineReducers(
  {
    classes: classesReducer,
    manageClasses: manageClassesReducer,
    meta: classesMetaReducer
  },
  () => new ClassStateSlice() as any
);
